import { Chip } from "@mui/material"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import { getInventoryLotStatusLabel } from "../../utils"

import { InventoryByLotStatus } from "@/graphql/codegen/graphql"

interface ProductInventoryLotStatusChipProps {
  status?: InventoryByLotStatus | null
}

const STATUS_TO_CLASS_NAME: Record<InventoryByLotStatus, string> = {
  [InventoryByLotStatus.Approved]: "bg-tertiary-green-100",
  [InventoryByLotStatus.DirectShip]: "bg-primary-200",
  [InventoryByLotStatus.NotEvaluated]: "bg-gray-100",
  [InventoryByLotStatus.OnHold]: "bg-tertiary-yellow-100",
  [InventoryByLotStatus.Pending]: "bg-gray-200",
  [InventoryByLotStatus.Rejected]: "bg-secondary-200",
} as const

export const ProductInventoryLotStatusChip: FC<ProductInventoryLotStatusChipProps> = ({ status }) => {
  if (!status) return null

  return (
    <Chip
      className={twMerge("h-6 rounded text-xs", STATUS_TO_CLASS_NAME[status])}
      label={getInventoryLotStatusLabel(status)}
    />
  )
}
